type LogArgs = unknown[];

export const logger = {
  debug: (...args: LogArgs): void => {
    // eslint-disable-next-line no-console
    console.debug(...args);
  },
  info: (...args: LogArgs): void => {
    // eslint-disable-next-line no-console
    console.info(...args);
  },
  warn: (...args: LogArgs): void => {
    // eslint-disable-next-line no-console
    console.warn(...args);
  },
  error: (...args: LogArgs): void => {
    // eslint-disable-next-line no-console
    console.error(...args);
  },
};
